export enum OfficeSchedulerModeEnum {
    Confirmations = 1,
    Rescheduling = 2,
}
